/** Expanded sidenav width (+15% vs original 250px). */
export const SIDENAV_WIDTH_PX = 288;

/** Collapsed icon rail — keep tight around 24px icons / 44px mark. */
export const SIDENAV_MINI_WIDTH_PX = 64;

const SIDENAV_CONTENT_GAP_PX = 16;

export const SIDENAV_CONTENT_MARGIN_EXPANDED_PX = SIDENAV_WIDTH_PX + SIDENAV_CONTENT_GAP_PX;

export const SIDENAV_CONTENT_MARGIN_MINI_PX = SIDENAV_MINI_WIDTH_PX + SIDENAV_CONTENT_GAP_PX;
